import customSelect from 'custom-select';

let type 
let page 
let ordre
let offre
let practice
//getParametres()

let selectTri 
let selectOffre 
let selectpractice





export const init = function () {
  customSelect('select');
  selectTri =  document.querySelector('#select_tri').customSelect
  selectOffre =  document.querySelector('#select_offre').customSelect
  selectpractice =  document.querySelector('#select_practice').customSelect


  selectOffre.select.addEventListener('change',(e) => { 
    offre = e.target.value
    page = 1
    setParametres()
    getActus(type,page)
  });

  selectpractice.select.addEventListener('change',(e) => { 
    practice = e.target.value
    page = 1
    setParametres()
    getActus(type,page)
  });
}

export const getActus = function (choixtype , pagetemp = 1) {

    type = choixtype
    getParametres()
       // const url ='https://veltys.dev/wp-json/veltys/v1/'+type+'/'+page+'/'+ordre+'/'+offres+'/'+practices   
    var lang = 'fr';
    if (window.location.href.indexOf("/en/") != -1) lang = 'en';

    const url = window.location.origin+'/wp-json/veltys/v1/getactualites?type='+type+'&page='+pagetemp+'&ordre='+ordre+'&offre='+offre+'&practice='+practice+'&nbr=9&dest=actus&lang='+lang
    console.log(url)
    
    fetch(url)
      .then((resp) => resp.json())
      .then(function(data) {
        

        page = pagetemp
        if (page == 1)  document.querySelector('.zone-load-actualites').innerHTML =   data
        else   document.querySelector('.zone-load-actualites').innerHTML =  document.querySelector('.zone-load-actualites').innerHTML + data
        setParametres()
    });   
}



const chargeActus = function () {
 
  //console.log("🚀 ~ file: actus.js ~ line 27 ~ chargeActus ~ page", page)
  // TODO Modifier l'url 
  // window.history.pushState("https://"+window.location.host,  'titre',"./"+currentCandidatUrl+"_comparaison_"+candidat2.post_name);

  getActus(type,page + 1)
}


const getParametres = function () {
  var urlParams = new URLSearchParams(window.location.search);
  page = parseInt(urlParams.get('page' ))
  ordre = urlParams.get('ordre' )
  offre = urlParams.get('offre' )
  practice = urlParams.get('practice' )

  if (!page) page = 1
  if (!ordre) ordre = 'desc'
  if (!offre) offre = 'toutes'
  if (!practice) practice = 'toutes'
}

const setParametres = function () {
  window.history.pushState("https://"+window.location.host,  'titre','./?ordre='+ordre+'&offre='+offre+'&practice='+practice);
}


const setChoix = function () {
  
}


if (document.querySelector('.bouton.charge-actualites') ) {
  document.querySelector('.bouton.charge-actualites').addEventListener('click', function () {
    chargeActus()
  })
}



